import { getData } from '../plugins/ApiCalls'

export function getFormExperimentVariants(formId, experimentId) {
  return getData('forms/' + formId + '/experiments/' + experimentId + '/variants')
}
